export default __webpack_public_path__ + "static/media/layer-blue.ab95817a.svg";